document.addEventListener('DOMContentLoaded', () => {
  // Handle financing data
  const productTitleLink = document.querySelector('a.product__title');
  if (productTitleLink)
    handleFinancingData(productTitleLink.href);

  // Handle financing form
  const productSelect = document.getElementById('product-select');
  if (productSelect)
  {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const productName = params.get('product');
    
    productSelect.value = productName;

    productSelect.addEventListener('change', function(){
      const productTitleLink = window.location.href.split(window.location.pathname)[0] + '/products/' + this.value
      console.log(productTitleLink);
      handleFinancingData(productTitleLink);
    })

    const productTitleLink = window.location.href.split(window.location.pathname)[0] + '/products/' + productName
    console.log(productTitleLink);
    handleFinancingData(productTitleLink);
  }

  // Handle "Abmessungen" dropdown
  const dropdown = document.getElementById('Details-collapsible-row-2-template--17597996794153__main');
  if (dropdown)
  {
    const dropdownContent = document.getElementById('ProductAccordion-collapsible-row-2-template--17597996794153__main');
    if (dropdownContent.querySelector('.metafield-rich_text_field') === null)
      dropdown.parentElement.style.display = 'none';
  
    // Handle unit price
    const unitPrice = document.querySelector('small.unit-price.caption')
    if (!unitPrice.classList.contains('hidden'))
    {
      unitPrice.style.fontSize = '18px'
      unitPrice.style.color = 'black';
  
      document.querySelector('.price__regular').style.display = 'none'
  
      const unit = unitPrice.querySelector('span.unit')
      console.log(unit.innerHTML)
      if (unit.innerHTML === 'l')
        unit.innerHTML = 'Stück'
      else if (unit.innerHTML === 'm')
        unit.innerHTML = "Meter"
  
      const discountedUnitPrices = document.querySelectorAll('.kaching-bundles__bar-unit-price');
      for (let i = 0; i < discountedUnitPrices.length; ++i)
        discountedUnitPrices[i].style.display = 'none';
    }
  }
});
let m_product = null;

function handleFinancingData(productTitleLink){
  const productURL = productTitleLink
  const options = {
      style: "currency",
      currency: "EUR"
  };

  console.log(productURL);
  
  fetch(productURL + '.js')
    .then(response => response.json())
    .then(product => {
      console.log(product);

      if (product.type === "Müllpresse" || product.type === "Abfallverdichter")
      {
        const financingWrapper = document.querySelector('.lxit--finacing-wraaper')
        if (financingWrapper)
          financingWrapper.style.display = 'block'

        const netfinancingRateWrapper = document.querySelector('.net-financing-rate-wrapper')
        if (netfinancingRateWrapper)
          netfinancingRateWrapper.style.display = 'block'
        
        const netFinancingRate = Math.round(product.price) / 73.7857 / 100;
        const financingRate = Math.round(product.price) / 73.7857 / 100 * 1.19;
        const finalRate = Math.round(product.price) * 1.19 * 0.3 / 100;
        const total = financingRate * 72 + finalRate;
        const productPriceNet = product.price / 100;
        const productPriceVat = product.price / 100 * 1.19;

        const formattedNetFinancingRate = netFinancingRate.toLocaleString('de-DE', options);
        const formattedfinancingRate = financingRate.toLocaleString('de-DE', options);
        const formattedfinalRate = finalRate.toLocaleString('de-DE', options);
        const formattedTotal = total.toLocaleString('de-DE', options);
        const formattedProductPriceNet = productPriceNet.toLocaleString('de-DE', options);
        const formattedProductPriceVat = productPriceVat.toLocaleString('de-DE', options);
  
        document.getElementById('product-title').innerHTML = product.title;
        document.getElementById('pricing-net').innerHTML = formattedProductPriceNet;
        document.getElementById('final-rate').innerHTML = formattedfinalRate;
        document.getElementById('total').innerHTML = formattedTotal;

        const netFinancingRateSpans = document.querySelectorAll('span.net-financing-rate');
        for (let i = 0; i < netFinancingRateSpans.length; ++i)
          netFinancingRateSpans[i].innerHTML = formattedNetFinancingRate;
  
        const financingRateSpans = document.querySelectorAll('span.financing-rate');
        for (let i = 0; i < financingRateSpans.length; ++i)
          financingRateSpans[i].innerHTML = formattedfinancingRate;
  
        const priceSpans = document.querySelectorAll('span.pricing-vat');
        for (let i = 0; i < priceSpans.length; ++i)
          priceSpans[i].innerHTML = formattedProductPriceVat;
  
        financingFormBtn = document.getElementById('financing-form-btn');
        if (financingFormBtn)
          financingFormBtn.addEventListener('click', function(){
            window.location = '/pages/finanzierungskauf?product=' + product.handle;
          });
      }
    });
}
